"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
const ui_1 = require("@completeanatomy/ui");
const styled_components_1 = __importDefault(require("styled-components"));
function OpacitySlider({ color, opacity, className, onChange, onAfterChange, }) {
    return ((0, jsx_runtime_1.jsxs)(Container, { className: className, "data-e2e": 'OpacitySlider_Container', children: [(0, jsx_runtime_1.jsx)(Background, { color: color, "data-e2e": 'OpacitySlider_Background' }), (0, jsx_runtime_1.jsx)(StyledSlider, { currentValue: opacity * 100, min: 10, max: 100, thumbClassName: "thumb", trackClassName: "track", orientation: "vertical", onChange: value => onChange(value / 100), onAfterChange: value => onAfterChange(value / 100), "data-e2e": 'OpacitySlider_StyledSlider' })] }));
}
exports.default = OpacitySlider;
const Container = styled_components_1.default.div `
  position: relative;

  display: flex;
  flex-direction: column;

  width: 20px;
  height: 250px;
`;
const Background = styled_components_1.default.div `
  position: absolute;
  top: 0;
  left: calc(50% - 1px);

  width: 2px;
  height: 100%;

  background: ${props => props.theme.white};

  &::after {
    position: absolute;
    top: 0;
    left: 0;

    width: 100%;
    height: 100%;

    background: linear-gradient(
      180deg,
      rgba(255, 255, 255, 0.1) 0%,
      ${props => props.color} 100%
    );

    content: ' ';
  }
`;
const StyledSlider = (0, styled_components_1.default)(ui_1.Slider) `
  display: flex;
  flex-grow: 1;
  justify-content: center;

  .track {
    width: 2px;
    height: auto;

    margin: auto;

    background: transparent;
  }

  .track-0 {
    background: transparent;
  }
`;
